import { IUpdateContaReceberUseCase } from "../../../presentation/useCases/update/update_conta_receber_use_case";
import { ContaReceber } from "../../models/conta_receber";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * UpdateContaReceberUseCase
 */

export class UpdateContaReceberUseCase implements IUpdateContaReceberUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async updateContaReceber(form: ContaReceber): Promise<number> {
    return this.repository.updateContaReceber(form);

  }
}
